import { COLOR } from '@src/styles/color';

export const variantMapping = {
  category: {
    border: `1px solid ${COLOR.borderDropdown}`,
    width: '154px',
    height: '40px',
    padding: '8px',
    widthPapers: '208px',
    gap: '8px',
  },
};
